import { render, staticRenderFns } from "./request-and-load.vue?vue&type=template&id=310cdb76&"
import script from "./request-and-load.vue?vue&type=script&lang=ts&"
export * from "./request-and-load.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports